/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_No_Options_ErrorInputs */

const en_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No export options selected.`)
};

const fr_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune option d'exportation selectionnee.`)
};

const de_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Exportoptionen ausgewählt.`)
};

const it_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna opzione di esportazione selezionata.`)
};

const ru_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры экспорта не выбраны.`)
};

const es_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay opciones de exportación seleccionadas.`)
};

const zh_cn2_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何导出选项。`)
};

const ja_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート オプションが選択されていません。`)
};

const hi_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई निर्यात विकल्प नहीं चुना गया।`)
};

const pt_pt2_audio_description_export_no_options_error = /** @type {(inputs: Audio_Description_Export_No_Options_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma opção de exportação selecionada.`)
};

/**
* | output |
* | --- |
* | "No export options selected." |
*
* @param {Audio_Description_Export_No_Options_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_no_options_error = /** @type {((inputs?: Audio_Description_Export_No_Options_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_No_Options_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_no_options_error(inputs)
	if (locale === "de") return de_audio_description_export_no_options_error(inputs)
	if (locale === "it") return it_audio_description_export_no_options_error(inputs)
	if (locale === "ru") return ru_audio_description_export_no_options_error(inputs)
	if (locale === "es") return es_audio_description_export_no_options_error(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_no_options_error(inputs)
	if (locale === "ja") return ja_audio_description_export_no_options_error(inputs)
	if (locale === "hi") return hi_audio_description_export_no_options_error(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_no_options_error(inputs)
	return en_audio_description_export_no_options_error(inputs)
});